import React from "react";

import Banner from "../../../sections/Banner/Banner";
import ContentBlock from "../../../sections/ContentBlock/ContentBlock";
import ImageCard from "../../../components/ImageCard/ImageCard";
// import Headshot from "../../../components/Headshot/Headshot";

// import logo from "../../../assets/DTC-logo.png";
import "./Athletes.css";
import athletes from "./athletes.json";
import FadeInSection from "../../../sections/FadeIn/FadeIn";

const Athletes = (props) => {
  const athleteList = [];
  for (let key in athletes) {
    let athlete = {
      ...athletes[key],
      id: key,
    };
    athleteList.push(athlete);
  }

  return (
    <div className="Athletes">
      <Banner
        img_src="https://districttrack.s3.us-east-2.amazonaws.com/v2/photos/running/edose-monument.jpg"
        img_alt="Edose Running at the Washington Monument"
      >
        <h1>Meet The Pros</h1>
      </Banner>
      <section>
        <FadeInSection>
          <h3 className="subheader">
            WE ARE RELENTLESS AND UNITED IN THE PURSUIT OF THIS DREAM.
          </h3>
        </FadeInSection>

        <ContentBlock>
          {athleteList.map((athlete) => (
            <ImageCard
              img_src={athlete["img"]}
              img_alt="Edose Smiling"
              to={"/our-team/" + athlete["id"]}
              buttonText="Read More"
              key={athlete["id"]}
            >
              <h4>{athlete["name"]}</h4>
              <h6 className="info">
                {athlete["event"]}, {athlete["country"]}
              </h6>
              {/* <img
                className="flagIcon"
                src={athlete["flag"]}
                alt={athlete["country"] + " flag"}
              /> */}
            </ImageCard>
          ))}
          <div className="invisible-athlete"></div>
          <div className="invisible-athlete"></div>
          <div className="invisible-athlete"></div>
        </ContentBlock>
        {/* {openAthlete}
        {mask} */}
      </section>
    </div>
  );
};

export default Athletes;
